import api from './api';

// ─── Pujas ───────────────────────────────────────────

export const fetchAllPujas = async (filters = {}) => {
  const response = await api.get('/epuja/pujas', { params: filters });
  return response.data;
};

export const fetchFeaturedPujas = async () => {
  const response = await api.get('/epuja/pujas/featured');
  return response.data;
};

export const fetchPujaCategories = async () => {
  const response = await api.get('/epuja/pujas/categories');
  return response.data;
};

export const fetchPujaById = async (id) => {
  const response = await api.get(`/epuja/pujas/${id}`);
  return response.data;
};

export const fetchPujaBySlug = async (slug) => {
  const response = await api.get(`/epuja/pujas/slug/${slug}`);
  return response.data;
};

// ─── Pandits ─────────────────────────────────────────

export const fetchAllPandits = async (filters = {}) => {
  const response = await api.get('/epuja/pandits', { params: filters });
  return response.data;
};

export const fetchPanditById = async (id) => {
  const response = await api.get(`/epuja/pandits/${id}`);
  return response.data;
};

// ─── Booking ─────────────────────────────────────────

export const validatePujaBooking = async (bookingData) => {
  const response = await api.post('/epuja/validate-booking', bookingData);
  return response.data;
};

// ─── Payments ────────────────────────────────────────

export const initiatePayment = async (bookingId) => {
  const response = await api.post('/payments/initiate', { bookingId });
  return response.data;
};

export const verifyPayment = async (merchantTransactionId, bookingId) => {
  const response = await api.post('/payments/verify', { merchantTransactionId, bookingId });
  return response.data;
};
